import scrollMonitor from 'scrollmonitor';
import scrollToElement from 'scroll-to-element';
import StickySidebar from 'sticky-sidebar';
import classnameToggle from './../../scripts/classname-toggle';
import toArray from './../../scripts/to-array';

toArray(document.querySelectorAll('[data-component="statement-slide"]')).forEach((component) => {
  // Visibility Checker
  const animation = component.querySelector('[data-statement-slide-animation] [data-component="animation"]').animationController;
  const componentWatcher = scrollMonitor.create(component);
  function visibilityChecker() {
    const isOpenAndVisible = componentWatcher.isInViewport && component.classList.contains('is-panel-open');
    classnameToggle(document.body, 'is-panel-open-and-visible', isOpenAndVisible);

    classnameToggle(component, 'is-above-viewport', componentWatcher.isAboveViewport);
    classnameToggle(component, 'is-below-viewport', componentWatcher.isBelowViewport);
    classnameToggle(component, 'is-fully-in-viewport', componentWatcher.isFullyInViewport);

    if (!isOpenAndVisible && componentWatcher.isInViewport) {
      setTimeout(() => animation.play(), 300);
    } else {
      animation.stop();
    }
  }

  componentWatcher.stateChange(visibilityChecker);
  visibilityChecker();

  // Panels
  const links = toArray(component.querySelectorAll('[data-statement-slide-link]'));
  const panelWrapper = component.querySelector('[data-statement-slide-panel-wrapper]');
  const panels = toArray(component.querySelectorAll('[data-statement-slide-panel]')).map(el => ({
    el,
    animation: el.querySelector('[data-component="animation"]').animationController,
  }));
  const panelClose = component.querySelector('[data-statement-slide-panel-close] [data-component="close-button"]');

  links.forEach(link =>
    link.addEventListener('click', (event) => {
      event.preventDefault();

      links.forEach(el => classnameToggle(el, 'is-active', el === link));
      panels.forEach((panel) => {
        const isActive = `#${panel.el.id}` === link.getAttribute('href');
        classnameToggle(panel.el, 'is-active', isActive);

        if (isActive) {
          panel.animation.play();
        } else {
          panel.el.removeAttribute('tabindex');
          panel.animation.stop();
        }
      });

      panelClose.setAttribute('tabindex', '0');
      component.classList.add('is-panel-open');
      document.body.classList.add('is-panel-open');

      panelWrapper.setAttribute('tabindex', '0');
      panelWrapper.scrollTo(0, 0);
      scrollToElement(panelWrapper, { ease: 'out-circ', duration: 200 });
      setTimeout(() => panelWrapper.focus(), 500);

      visibilityChecker();
    }));

  toArray(component.querySelectorAll('[data-statement-slide-panel-close], [data-statement-slide-overlay]')).forEach(el =>
    el.addEventListener('click', () => {
      links.forEach((link) => {
        if (link.classList.contains('is-active')) {
          link.focus();
          link.classList.remove('is-active');
        }
      });
      panels.forEach(panel => panel.animation.stop());

      panelClose.setAttribute('tabindex', '-1');
      component.classList.remove('is-panel-open');
      document.body.classList.remove('is-panel-open');

      panelWrapper.setAttribute('tabindex', '-1');

      visibilityChecker();
    }));

  // Animation Sticky
  const animationSticky = component.querySelector('[data-statement-slide-animation-sticky]');
  if (animationSticky) {
    new StickySidebar(animationSticky); // eslint-disable-line no-new
  }
});
